// Catálogo de descripciones disponibles para preguntas
// Basado en los datos encontrados en la infraestructura de la base de datos

export const QUESTION_DESCRIPTIONS = [
  { value: 'Coaches, Psicólogos', label: 'Coaches, Psicólogos' },
  { value: 'Líderes de equipos', label: 'Líderes de equipos' },
  { value: 'Brief de marca', label: 'Brief de marca' },
  { value: 'Equipos de innovación', label: 'Equipos de innovación' },
  { value: 'Emociones: sentimientos incómodos', label: 'Emociones: sentimientos incómodos' },
  { value: 'Emociones: sentimientos positivos', label: 'Emociones: sentimientos positivos' },
  { value: 'Necesidades', label: 'Necesidades' },
  { value: 'Procesos', label: 'Procesos' },
  { value: 'Propia condición interior', label: 'Propia condición interior' },
  { value: 'Relación con otros', label: 'Relación con otros' },
  { value: 'Desarrollo personal', label: 'Desarrollo personal' },
  { value: 'Liderazgo', label: 'Liderazgo' },
  { value: 'Trabajo en equipo', label: 'Trabajo en equipo' },
  { value: 'Comunicación', label: 'Comunicación' },
  { value: 'Creatividad', label: 'Creatividad' },
  { value: 'Resolución de problemas', label: 'Resolución de problemas' },
  { value: 'Gestión de proyectos', label: 'Gestión de proyectos' },
  { value: 'Evaluación de desempeño', label: 'Evaluación de desempeño' },
  { value: 'Feedback', label: 'Feedback' },
  { value: 'Otro', label: 'Otro' }
];

// Función para obtener todas las descripciones como opciones para react-select
export const getDescriptionOptions = () => {
  return QUESTION_DESCRIPTIONS;
};

// Función para validar si una descripción es válida
export const isValidDescription = (description) => {
  return QUESTION_DESCRIPTIONS.some(desc => desc.value === description);
};

// Función para obtener la etiqueta de una descripción
export const getDescriptionLabel = (value) => {
  const description = QUESTION_DESCRIPTIONS.find(desc => desc.value === value);
  return description ? description.label : value;
};
